import { TextBody, useModalContext, Icon } from '@ally/metronome-ui';
import { Modal } from '../../molecules';
import styled from 'styled-components';
import { muiQuestionCircleOutline } from '@ally/metronome-icons';

const StyledIconButton = styled.button`
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    opacity: 0.8;
  }
`;

interface IProps {}

// This needs to be a separate component so that it can grab the parent modal context from it's parent modal component
const ModalTrigger: React.FC = () => {
  const { setOpen } = useModalContext();

  return (
    <StyledIconButton
      aria-label='More information about TIN'
      onClick={() => setOpen(true)}
    >
      <Icon icon={muiQuestionCircleOutline} size='md' />
    </StyledIconButton>
  );
};

const TinModal: React.FC<IProps> = (props: IProps) => {
  return (
    <Modal
      heading="What's a Taxpayer Identification Number?"
      headingProps={{ fontSize: '1.6rem' }}
      content={
        <>
          <TextBody tag='p' size='md'>
            For individuals, this is your Social Security Number or Individual
            Tax Identification Number (ITIN). It should match the first name
            listed on the account and will be used for tax reporting purposes.
          </TextBody>
        </>
      }
      trigger={<ModalTrigger />}
      width='md'
    />
  );
};

export default TinModal;
